import script from "./SynapsesList.vue?vue&type=script&setup=true&lang=js"
export * from "./SynapsesList.vue?vue&type=script&setup=true&lang=js"

import "./SynapsesList.vue?vue&type=style&index=0&id=e9adec1c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9adec1c"]])

export default __exports__